import { createApp } from "vue";
import VueCookies from "vue3-cookies";
import VueSmoothScroll from "vue3-smooth-scroll";
import App from "./App.vue";
import { errorHandler } from '@/services/error-handler'
import { registerGlobalErrors } from '@/plugins/register-global-errors'
import vuetify from "./plugins";

import router from "./multipages";
import store from "./stores";
const gaId = import.meta.env.VITE_GA_ID;
const fingerprintAPIKey = import.meta.env.VITE_FINGERPRINT_API_KEY;

import * as VueGoogleMaps from "vue3-google-map";
import { createMetaManager } from "vue-meta";
import { plugin as vueMetaPlugin } from "vue-meta";
import {
  fpjsPlugin,
  FingerprintJSPro,
} from "@fingerprintjs/fingerprintjs-pro-vue-v3";

const _fetch = window.fetch;
window.fetch = (url, ...args) => {
  let urlStr;
  try {
    urlStr = typeof url === 'string'
      ? url
      : url instanceof Request
        ? url.url
        : url?.toString?.();
  } catch {
    urlStr = 'unknown';
  }

  return _fetch(url, ...args).catch(err => {
    console.log('unreachable', urlStr);
    // clone error instead of mutating
    const enrichedErr = Object.assign(
      Object.create(Object.getPrototypeOf(err)),  // ← keep TypeError prototype
      err,                                         // ← copy all original properties
      { requestUrl: urlStr }                       // ← add your property
    );
    throw enrichedErr; // ← Datadog gets original-like error, you get URL ✅
  });
};

const app = createApp(App);
// Catch Vue component errors and send it to datadog
app.config.errorHandler = (error, instance, info) => {
  errorHandler.send(error, {
    type: 'vue-error',
    componentName: instance?.$options?.name || 'UnknownComponent',
    componentInfo: info,
  })
}
app.config.warnHandler = (msg, instance, trace) => {
  // only capture missing-property warnings
  if (msg.includes('is not defined on instance')) {
    errorHandler.send(new Error(msg), {
      type: 'vue-warning',
      componentName: instance?.$options?.name || 'UnknownComponent',
      componentInfo: trace,
    })
  }
  // keep Vue warning in console too
  console.warn(msg, trace)
}
registerGlobalErrors()

app.use(vuetify);
app.use(VueSmoothScroll);
app.use(VueCookies);
app.use(VueGoogleMaps, {
  load: {
    key: "AIzaSyDmHp0PPuKHD1KGHCDmLq1qQKr_03XKEHo",
    libraries: ["places", "geometry"],
  },
});

app.use(fpjsPlugin, {
  loadOptions: {
    apiKey: fingerprintAPIKey,
    endpoint: ["https://a.crane.com", FingerprintJSPro.defaultEndpoint],
    scriptUrlPattern: [
      `https://a.crane.com/web/v<version>/<apiKey>/loader_v<loaderVersion>.js`,
      FingerprintJSPro.defaultScriptUrlPattern,
    ],
  },
});

app.config.productionTip = false;
app.use(store);
app.use(router);
router.afterEach((to, from) => {
  if (window.Appcues && typeof window.Appcues.page === "function") {
    window.Appcues.page();
    console.log("Appcues is loaded.");
  } else {
    console.log("Appcues is not loaded yet.");
  }
});
app.use(vueMetaPlugin);
app.use(
  createMetaManager(false, {
    description: {
      tag: "meta",
    },
    titleTemplate: {
      tag: "title",
    },
    title: {
      tag: "meta",
    },
    robots: {
      tag: "meta",
    },
    keywords: {
      tag: "meta",
    },
  })
);
app.mount("#app");
